import { createContext, useContext } from 'react';

const OrderContext = createContext();

export const useOrder = () => useContext(OrderContext);

export default function OrdrContextProvider({ order, orderLoading, children }) {
    return (
        <OrderContext.Provider value={{ order, orderLoading }}>
            {children}
        </OrderContext.Provider>
    )
}
